import {Component, OnInit} from '@angular/core';
import {CSCProviders, CscService} from "../services/CscService";

@Component({
    selector: 'app-csc',
    standalone: true,
    imports: [],
    templateUrl: './csc.component.html',
    styleUrl: './csc.component.scss'
})
export class CscComponent implements OnInit {

    authorizationUrl!: string;

    constructor(private cscService: CscService) {
    }

    ngOnInit(): void {
        this.getAuthorize()
    }

    async getAuthorize(): Promise<void> {

        //http://localhost:4200/csccallback?error=access_denied&state=175a7c3e-57ec-42c6-bbf1-4033b8eab11c
        try {
            this.authorizationUrl = await this.cscService.getAuthorizceUrlPromise(CSCProviders.S8).then(value => {
                console.log(this.authorizationUrl);
                window.location.href = value;

                return value;
            });


        } catch (error) {
            console.error('Error fetching authorization URL:', error);
        }
    }
}
